<app-loading-spinner [active]="loadingContent"></app-loading-spinner>

<form [formGroup]="form" (keydown.enter)="handleKeyEnter($event)">
    <div class="row no-gutters w-100">
        <div class="col-12 col-lg-10">
            <div class="row">
                <div class="col-12" *ngIf="data.length === 0">
                    <div class="info-message">
                        <svg-icon src="assets/images/icon-info.svg"></svg-icon>
                        <span>
                            É necessário adicionar pelo menos um representante
                            <span *ngIf="isAssignor">ou Avalista/Dev.
                                Solidário.</span>
                        </span>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>
            <ng-container *ngIf="!showForm ">

                <div class="row" *ngIf="data.length > 0">
                    <div class="col-12">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="expand-column"></th>
                                    <th>Nome/Razão social</th>
                                    <th>CPF/CNPJ</th>
                                    <th>Tipo</th>
                                    <th *ngIf="signupService.getIsFund()">Perfil
                                    </th>
                                    <th *ngIf="isAssignor">Perfil</th>
                                    <th class="actions-column">Ações</th>
                                </tr>
                            </thead>

                            <tbody>
                                <ng-container
                                    *ngFor="let item of data; let i = index">
                                    <!-- Main row -->
                                    <tr>
                                        <td class="expand-column">
                                            <button
                                                *ngIf="isCompanyRepresentative(item)"
                                                (click)="toggleRowExpansion(i)"
                                                class="expand-button"
                                                type="button">
                                                <svg-icon
                                                    src="assets/images/icon-right.svg"
                                                    *ngIf="!isRowExpanded(i)"></svg-icon>
                                                <svg-icon
                                                    src="assets/images/icon-down.svg"
                                                    *ngIf="isRowExpanded(i)"></svg-icon>
                                            </button>
                                        </td>
                                        <td>{{getRepresentativeName(item)}}</td>
                                        <td>{{getRepresentativeDocument(item)}}
                                        </td>
                                        <td>{{getRepresentativeType(item)}}</td>
                                        <td *ngIf="signupService.getIsFund()">
                                            {{renderFundProfile(item)}}
                                        </td>
                                        <td *ngIf="isAssignor">
                                            {{renderType(item)}}</td>
                                        <td class="actions-column">
                                            <div
                                                class="d-flex justify-content-end">
                                                <ng-container
                                                    *ngIf="needPartner(i)">
                                                    <app-tooltip
                                                        text="Adicionar cônjuge"
                                                        position="top">
                                                        <button
                                                            class="app-table-remove mr-2"
                                                            (click)="handleAddPartner(i)">
                                                            <svg-icon
                                                                src="assets/images/icon-wedding.svg"></svg-icon>
                                                        </button>
                                                    </app-tooltip>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="canEditRepresentative(item)">
                                                    <app-tooltip text="Editar"
                                                        position="top">
                                                        <button
                                                            class="app-table-remove mr-2"
                                                            (click)="handleEditData(i)">
                                                            <svg-icon
                                                                src="assets/images/icon-edit.svg"
                                                                fill="var(--white)"></svg-icon>
                                                        </button>
                                                    </app-tooltip>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="!canEditRepresentative(item)">
                                                    <span
                                                        style="width: 32px; display: inline-block;"></span>
                                                </ng-container>
                                                <app-tooltip text="Excluir"
                                                    position="top">
                                                    <button
                                                        class="app-table-remove trash-icon"
                                                        (click)="handleRemoveData(i)">
                                                        <svg-icon
                                                            src="assets/images/icon-trash.svg"></svg-icon>
                                                    </button>
                                                </app-tooltip>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Expanded row for company representatives -->
                                    <tr *ngIf="isCompanyRepresentative(item) && isRowExpanded(i)"
                                        class="expanded-row-content">
                                        <td [attr.colspan]="isAssignor ? 6 : 5">
                                            <div class="sub-table-container">
                                                <h4>Representantes vinculados
                                                </h4>

                                                <div *ngIf="isLoadingCompanyReps(i)"
                                                    class="p-3">
                                                    <ngx-skeleton-loader
                                                        [theme]="{ height: '40px', width: '100%', marginBottom: '8px' }"
                                                        count="2"></ngx-skeleton-loader>
                                                </div>

                                                <div
                                                    *ngIf="!isLoadingCompanyReps(i)">
                                                    <table
                                                        *ngIf="getCompanyRepresentatives(i).length > 0"
                                                        class="sub-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Nome</th>
                                                                <th>Documento
                                                                </th>
                                                                <th>Assina</th>
                                                                <th>Obrigatório
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                *ngFor="let rep of getCompanyRepresentatives(i)">
                                                                <td>{{ rep.name
                                                                    }}</td>
                                                                <td>{{
                                                                    formatCpfCnpj(rep.document)
                                                                    }}</td>
                                                                <td>{{
                                                                    rep.canSign
                                                                    ? 'Sim' :
                                                                    'Não' }}
                                                                </td>
                                                                <td>{{
                                                                    rep.isMandatory
                                                                    ? 'Sim' :
                                                                    'Não' }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div *ngIf="getCompanyRepresentatives(i).length === 0"
                                                        class="text-center p-3 text-muted">
                                                        Nenhum representante
                                                        vinculado encontrado.
                                                    </div>

                                                </div>

                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>

                        <app-spacer [bottom]="32"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6 d-flex">
                        <app-button (onClick)="clearForm()" [disabled]="sending"
                            *ngIf="showForm" [outline]="true" class="mr-3">
                            Redefinir campos
                        </app-button>

                        <app-button (onClick)="triggerForm()"
                            [loading]="sending" [disabled]="getDisabled()"
                            class="add-button" type="submit"
                            [outline]="data.length > 0">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>
                            {{data.length > 0 ? 'Adicionar outro representante'
                            :
                            'Adicionar representante'}}
                        </app-button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="showForm">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex align-items-center mb-2">
                            <label class="pep-title mr-1" style="margin: 0;">
                                Tipo de representante
                            </label>
                        </div>
                        <div class="d-flex">
                            <app-radio [multiple]="false"
                                [isChecked]="form.controls.representative_type.value === 'person'"
                                (onCheckChanged)="handleRepresentativeTypeChange($event, 'person')"
                                [value]="'person'">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">Pessoa
                                        Representante</span>
                                </div>
                            </app-radio>
                            <app-spacer [right]="24"></app-spacer>
                            <app-radio [multiple]="false"
                                [isChecked]="form.controls.representative_type.value === 'company'"
                                (onCheckChanged)="handleRepresentativeTypeChange($event, 'company')"
                                [value]="'company'">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">Empresa
                                        Representante</span>
                                </div>
                            </app-radio>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <ng-container
                    *ngIf="form.controls.representative_type.value === 'company'">
                    <ng-container *ngIf="signupService.getIsFund()">
                        <div class="row">
                            <div class="col-12">
                                <label class="pep-title mb-2">Perfil do
                                    representante</label>
                                <div class="d-flex">
                                    <app-radio [multiple]="true"
                                        formControlName="is_adm">
                                        Administrador
                                    </app-radio>
                                    <app-spacer [right]="24"></app-spacer>
                                    <app-radio [multiple]="true"
                                        formControlName="is_manager">
                                        Gestor
                                    </app-radio>
                                </div>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>
                    </ng-container>

                    <div class="row">
                        <div class="col-12"
                            *ngIf="companyLookupName || loadingCompanyRepresentatives">
                            <label class="pep-title"
                                *ngIf="selectedRepresentative === null">Empresa
                                encontrada</label>
                            <div style="font-weight: 600; font-size: 18px;">
                                <ngx-skeleton-loader
                                    *ngIf="loadingCompanyRepresentatives"
                                    [theme]="{ height: '20px', width: '320px', marginBottom: '0' }"></ngx-skeleton-loader>
                                <ng-container
                                    *ngIf="!loadingCompanyRepresentatives">
                                    {{ companyLookupName | uppercase }}
                                </ng-container>
                            </div>

                            <app-spacer [bottom]="16"></app-spacer>

                            <ng-container
                                *ngIf="selectedRepresentative === null">
                                <app-spacer [bottom]="16"></app-spacer>
                                <label class="pep-title">Representantes
                                    vinculados</label>
                                <div *ngIf="loadingCompanyRepresentatives"
                                    class="skeleton-table">
                                    <ngx-skeleton-loader [theme]="{
                                height: '72px',
                                width: '100%',
                                marginBottom: '0'
                            }">
                                    </ngx-skeleton-loader>
                                </div>
                                <app-table
                                    *ngIf="!loadingCompanyRepresentatives && companyRepresentatives.length > 0"
                                    [columns]="companyRepresentativesColumns"
                                    [data]="companyRepresentatives"
                                    [removeButton]="true">
                                </app-table>
                                <div *ngIf="!loadingCompanyRepresentatives && companyRepresentatives.length === 0"
                                    class="pep-title">
                                    Nenhum representante vinculado
                                </div>

                                <!-- Alerta de empresa não homologada (Modal) -->
                                <div *ngIf="companyLookupStatus && companyLookupStatus !== 'homologado'"
                                    class="mt-3 p-3 rounded d-flex align-items-center representative-error-alert">
                                    <svg-icon
                                        src="assets/images/icon-warning.svg"></svg-icon>
                                    <span>
                                        Esta empresa possui o status <strong>{{
                                            companyLookupStatus | uppercase
                                            }}</strong>.
                                        Somente empresas homologadas podem ser
                                        vinculadas como representantes.
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>


                    <!-- CNPJ Text Display for Edit Mode -->
                    <div class="row"
                        *ngIf="selectedRepresentative !== null && !loadingCompanyRepresentatives">
                        <div class="col-12"
                            style="font-weight: 500; font-size: 16px; margin-bottom: 16px;">
                            CNPJ: {{ form.controls.cnpj.value }}
                        </div>
                    </div>

                    <div class="row"
                        *ngIf="selectedRepresentative === null || selectedRepresentative === undefined">
                        <div class="col-12 col-lg-6">
                            <app-masked-input [group]="form" controlName="cnpj"
                                label="CNPJ" placeholder="00.000.000/0000-00"
                                documentType="cnpj"
                                (onChange)="searchCompanyByCnpj($event)">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row"
                        *ngIf="companyLookupStatus === 'homologado'">
                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                controlName="term_validity" mask="00/00/0000"
                                label="Início do mandato"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                [readOnly]="isIndefinite"
                                controlName="max_term_validity"
                                mask="00/00/0000" label="Validade do mandato"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-spacer [bottom]="36"></app-spacer>
                            <app-radio [multiple]="true"
                                formControlName="indefinite_term">
                                Validade indeterminada
                            </app-radio>
                        </div>
                    </div>
                </ng-container>

                <ng-container
                    *ngIf="signupService.getIsFund() && form.controls.representative_type.value === 'person'">
                    <div class="row">
                        <div class="col-12">
                            <label class="pep-title mb-2">Perfil do
                                representante</label>
                            <div class="d-flex">
                                <app-radio [multiple]="true"
                                    formControlName="is_adm">
                                    Administrador
                                </app-radio>
                                <app-spacer [right]="24"></app-spacer>
                                <app-radio [multiple]="true"
                                    formControlName="is_manager">
                                    Gestor
                                </app-radio>
                            </div>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>
                </ng-container>

                <div class="row"
                    *ngIf="form.controls.representative_type.value === 'person'">
                    <div class="col-12 col-lg-4 cep-container">
                        <app-masked-input [group]="form" controlName="document"
                            label="CPF" placeholder="000.000.000-00"
                            mask="000.000.000-00"
                            (onChange)="searchRepresentative($event)">
                        </app-masked-input>
                        <svg-icon src="assets/images/icon-loading.svg"
                            *ngIf="loadingRepresentative"
                            class="app-button-icon"></svg-icon>
                    </div>
                </div>

                <app-spacer [bottom]="24"></app-spacer>



                <ng-container
                    *ngIf="form.controls.representative_type.value === 'person' && representativeFetched && isCpfValid()">
                    <div class="row" *ngIf="isAssignor">
                        <div class="col-12">
                            <div class="d-flex align-items-center mb-2"
                                style="position: relative;">
                                <label class="pep-title mr-1"
                                    style="margin: 0;">
                                    <span *ngIf="!isTypeSelected()"
                                        class="required-field"
                                        [class.error]="!isTypeSelected()">*</span>
                                    Tipo de representante
                                </label>
                            </div>
                            <div class="d-flex">
                                <app-radio [multiple]="false"
                                    formControlName="is_representative">
                                    <div class="flex-1 d-flex flex-column">
                                        <span
                                            class="pep-title">Representante</span>
                                    </div>
                                </app-radio>
                                <app-spacer [right]="24"></app-spacer>

                                <app-radio [multiple]="false"
                                    formControlName="guarantor">
                                    <div class="flex-1 d-flex flex-column">
                                        <span class="pep-title">Avalista</span>
                                    </div>
                                </app-radio>
                                <app-spacer [right]="24"></app-spacer>

                                <app-radio [multiple]="false"
                                    formControlName="solidarity_debtor">
                                    <div class="flex-1 d-flex flex-column">
                                        <span class="pep-title">Devedor
                                            solidário</span>
                                    </div>
                                </app-radio>
                            </div>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-8">
                            <app-input [group]="form" controlName="full_name"
                                label="Nome Completo" [maxLength]="60">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                controlName="birth_date" mask="00/00/0000"
                                label="Data de nascimento"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-select
                                [items]="signupService.choices().marital_choices"
                                [group]="form" controlName="marital_status"
                                label="Estado civil" placeholder="Selecione">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <ng-container
                        *ngIf="form.controls.marital_status.value === '2' || this.form.controls['marital_status'].value === '3'">
                        <div class="row">
                            <div class="col-12 col-lg-4">
                                <app-masked-input [group]="form"
                                    controlName="spouse_document"
                                    label="CPF do cônjuge"
                                    placeholder="000.000.000-00"
                                    mask="000.000.000-00">
                                </app-masked-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-masked-input [group]="form"
                                    controlName="spouse_name"
                                    label="Nome do cônjuge" mask="W*"
                                    [usePatterns]="true"
                                    [readOnly]="foundSpouse">
                                </app-masked-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-select
                                    [items]="signupService.choices().marital_statutes"
                                    [group]="form" controlName="spouse_statute"
                                    label="Regime de casamento">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12" *ngIf="showUxoria">
                                <app-spacer [top]="4"></app-spacer>
                                Possui outorga uxória?
                                <app-tooltip
                                    text="É o consentimento que o cônjuge precisa dar ao outro para realizar determinados negócios jurídicos"
                                    position="top">
                                    <svg-icon src="assets/images/icon-info.svg"
                                        fill="var(--alternative-gray)"
                                        style="margin-left: 8px; cursor: pointer; font-size: 14px;"></svg-icon>
                                </app-tooltip>
                                <app-spacer [bottom]="16"></app-spacer>

                                <div class="d-flex">
                                    <app-radio
                                        [isChecked]="form.controls.spousal_consent.value === 1"
                                        (onCheckChanged)="handleSpousalConsentClick($event, 1)"
                                        [value]="1">
                                        Sim
                                    </app-radio>
                                    <app-spacer [right]="32"></app-spacer>
                                    <app-radio
                                        [isChecked]="form.controls.spousal_consent.value === 2"
                                        (onCheckChanged)="handleSpousalConsentClick($event, 2)"
                                        [value]="2">
                                        Não
                                    </app-radio>
                                </div>
                                <app-spacer [bottom]="48"></app-spacer>
                            </div>
                        </div>
                    </ng-container>

                    <div class="row">
                        <div class="col-12 col-lg-12">
                            <app-input [group]="form" controlName="occupation"
                                [maxLength]="30" label="Ocupação Profissional">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-3">
                            <app-select
                                [items]="signupService.nationalityChocies"
                                [group]="form" controlName="nationality"
                                label="País de origem">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-2">
                            <app-select [items]="signupService.ufs_ids"
                                [group]="form" controlName="naturalness"
                                [readOnly]="isForeign" label="Naturalidade">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-select [items]="cities_options" [group]="form"
                                controlName="naturalness_city" label="Cidade"
                                [readOnly]="!form.controls.naturalness.value"
                                [placeholder]="form.controls.naturalness.value ? 'Selecione a cidade' : 'Selecione um Estado primeiro'">
                            </app-select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-select
                                [items]="signupService.choices().document_types"
                                [group]="form" controlName="document_type"
                                label="Tipo de documento">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-input [group]="form" controlName="rg"
                                [maxLength]="20" label="Número do Documento">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-select [items]="signupService.issuingAgencies"
                                [group]="form" controlName="issuing_agency"
                                label="Órgão expedidor">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-2">
                            <app-select [items]="signupService.ufs"
                                [group]="form" controlName="issuing_uf"
                                label="UF">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                controlName="shipping_date" mask="00/00/0000"
                                label="Data expedição" placeholder="dd/mm/aaaa">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-2">
                            <app-select [group]="form"
                                controlName="celphone_ddi" [items]="DDIOptions"
                                label="DDI">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                controlName="celphone_number" label="Celular"
                                mask="(00) 00000-0000"
                                placeholder="(00) 00000-0000">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-input [group]="form" controlName="email"
                                label="E-mail">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row" *ngIf="showTermValidity">
                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                controlName="term_validity" mask="00/00/0000"
                                label="Início do mandato"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>

                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                [readOnly]="isIndefinite"
                                controlName="max_term_validity"
                                mask="00/00/0000" label="Validade do mandato"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-spacer [bottom]="36"></app-spacer>
                            <app-radio [multiple]="true"
                                formControlName="indefinite_term">
                                Validade indeterminada
                            </app-radio>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <app-radio [multiple]="true" formControlName="pep">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">Considera-se
                                        PEP</span>
                                    <app-spacer [bottom]="8"></app-spacer>
                                    <span class="pep-description">Considera-se
                                        Pessoa
                                        Exposta Politicamente (PEP), nos termos
                                        da
                                        legislação em
                                        vigor, (i) agente público que desempenha
                                        ou
                                        tenha desempenhado, nos últimos cinco
                                        anos,
                                        no
                                        Brasil ou em
                                        países, territórios e dependências
                                        estrangeiras,
                                        cargos, empregos ou funções públicas
                                        relevantes; ou
                                        (ii) representante, familiar (parente na
                                        linha
                                        reta até primeiro grau, cônjuge,
                                        companheiro(a) ou
                                        enteado(a)).</span>
                                </div>
                            </app-radio>
                            <app-spacer [bottom]="48"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4 cep-container">
                            <app-masked-input [group]="form"
                                controlName="zipcode" label="CEP"
                                mask="00000-000" placeholder="00000-000"
                                (input)="handleSearchZipcode($event)">
                            </app-masked-input>
                            <svg-icon src="assets/images/icon-loading.svg"
                                *ngIf="searchingZipcode"
                                class="app-button-icon"></svg-icon>
                        </div>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>

                    <ng-container *ngIf="zipcodeFetched">
                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <app-input [group]="form"
                                    controlName="public_place" [maxLength]="30"
                                    label="Logradouro">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-2">
                                <app-input [group]="form" controlName="number"
                                    label="Número">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-input [group]="form"
                                    controlName="complement" [maxLength]="20"
                                    label="Complemento">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <app-input [group]="form" controlName="district"
                                    [maxLength]="30" label="Bairro">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-input [group]="form" controlName="city"
                                    [maxLength]="30" label="Cidade">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-2">
                                <app-select [items]="signupService.ufs"
                                    [group]="form" controlName="uf" label="UF">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-select
                                    [items]="signupService.nationalityChocies"
                                    [group]="form" controlName="country"
                                    label="País">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>
                    </ng-container>

                    <div class="row"
                        *ngIf="representativeFetched && isCpfValid()">
                        <div class="col-12 col-lg-6 d-flex">
                            <app-button (onClick)="clearForm()"
                                [disabled]="sending" [outline]="true"
                                class="mr-3">
                                Redefinir campos
                            </app-button>

                            <app-button (onClick)="triggerForm()"
                                [loading]="sending" [disabled]="getDisabled()"
                                class="add-button" type="submit">
                                {{ selectedRepresentative !== null ? 'Salvar
                                representante' : 'Adicionar representante' }}
                            </app-button>
                        </div>
                    </div>
                </ng-container>

                <div class="row"
                    *ngIf="form.controls.representative_type.value === 'company' && companyLookupName && !loadingCompanyRepresentatives && (companyLookupStatus === 'homologado' || selectedRepresentative !== null)">
                    <div class="col-12 col-lg-6 d-flex">
                        <app-button (onClick)="clearForm()" [disabled]="sending"
                            [outline]="true" class="mr-3">
                            Redefinir campos
                        </app-button>

                        <app-button (onClick)="triggerForm()"
                            [loading]="sending" [disabled]="getDisabled()"
                            class="add-button" type="submit">
                            {{ selectedRepresentative !== null ? 'Salvar
                            representante' : 'Adicionar representante' }}
                        </app-button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>



    <app-side-modal [active]="addAnotherModal" [title]="renderTitle()"
        (onClose)="handleCloseModal()" paddingBottom="0">
        <div class="container">
            <div class="row" *ngIf="selectedRepresentative === null">
                <div class="col-12">
                    <div class="d-flex align-items-center mb-2">
                        <label class="pep-title mr-1" style="margin: 0;">
                            Tipo de representante
                        </label>
                    </div>
                    <div class="d-flex">
                        <app-radio [multiple]="false"
                            [isChecked]="form.controls.representative_type.value === 'person'"
                            (onCheckChanged)="handleRepresentativeTypeChange($event, 'person')"
                            [value]="'person'">
                            <div class="flex-1 d-flex flex-column">
                                <span class="pep-title">Pessoa
                                    Representante</span>
                            </div>
                        </app-radio>
                        <app-spacer [right]="24"></app-spacer>
                        <app-radio [multiple]="false"
                            [isChecked]="form.controls.representative_type.value === 'company'"
                            (onCheckChanged)="handleRepresentativeTypeChange($event, 'company')"
                            [value]="'company'">
                            <div class="flex-1 d-flex flex-column">
                                <span class="pep-title">Empresa
                                    Representante</span>
                            </div>
                        </app-radio>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>

            <ng-container *ngIf="signupService.getIsFund()">
                <div class="row">
                    <div class="col-12">
                        <label class="pep-title mb-2">Perfil do
                            representante</label>
                        <div class="d-flex">
                            <app-radio [multiple]="true"
                                formControlName="is_adm">
                                Administrador
                            </app-radio>
                            <app-spacer [right]="24"></app-spacer>
                            <app-radio [multiple]="true"
                                formControlName="is_manager">
                                Gestor
                            </app-radio>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>
            </ng-container>

            <ng-container
                *ngIf="form.controls.representative_type.value === 'company'">
                <div class="row" *ngIf="selectedRepresentative === null">
                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form" controlName="cnpj"
                            label="CNPJ" placeholder="00.000.000/0000-00"
                            documentType="cnpj"
                            (onChange)="searchCompanyByCnpj($event)">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12"
                        *ngIf="companyLookupName || loadingCompanyRepresentatives">
                        <label class="pep-title"
                            *ngIf="selectedRepresentative === null">Empresa
                            encontrada</label>
                        <div style="font-weight: 600; font-size: 18px;">
                            <ngx-skeleton-loader
                                *ngIf="loadingCompanyRepresentatives"
                                [theme]="{ height: '20px', width: '320px', marginBottom: '0' }"></ngx-skeleton-loader>
                            <ng-container
                                *ngIf="!loadingCompanyRepresentatives">
                                {{ companyLookupName | uppercase }}
                            </ng-container>
                        </div>
                        <!-- CNPJ Text Display for Edit Mode -->
                        <div *ngIf="selectedRepresentative !== null && !loadingCompanyRepresentatives"
                            style="font-weight: 500; font-size: 16px; margin-top: 4px; margin-bottom: 16px;">
                            CNPJ: {{ form.controls.cnpj.value }}
                        </div>
                        <app-spacer [bottom]="16"></app-spacer>

                        <app-spacer [bottom]="16"></app-spacer>
                        <label class="pep-title">Representantes
                            vinculados</label>
                        <div *ngIf="loadingCompanyRepresentatives"
                            class="skeleton-table">
                            <ngx-skeleton-loader [theme]="{
                            height: '72px',
                            width: '100%',
                            marginBottom: '0'
                        }">
                            </ngx-skeleton-loader>
                        </div>
                        <app-table
                            *ngIf="!loadingCompanyRepresentatives && companyRepresentatives.length > 0"
                            [columns]="companyRepresentativesColumns"
                            [data]="companyRepresentatives"
                            [removeButton]="true">
                        </app-table>
                        <div *ngIf="!loadingCompanyRepresentatives && companyRepresentatives.length === 0"
                            class="pep-title">
                            Nenhum representante vinculado
                        </div>

                        <!-- Alerta de empresa não homologada (Modal) -->
                        <div *ngIf="selectedRepresentative === null && companyLookupStatus && companyLookupStatus !== 'homologado'"
                            class="mt-3 p-3 rounded d-flex align-items-center representative-error-alert">
                            <svg-icon
                                src="assets/images/icon-warning.svg"></svg-icon>
                            <span>
                                Esta empresa possui o status <strong>{{
                                    companyLookupStatus | uppercase
                                    }}</strong>.
                                Somente empresas homologadas podem ser
                                vinculadas como representantes.
                            </span>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row"
                    *ngIf="companyLookupName && !loadingCompanyRepresentatives && (companyLookupStatus === 'homologado' || selectedRepresentative !== null)">
                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form"
                            controlName="term_validity" mask="00/00/0000"
                            label="Início do mandato" placeholder="dd/mm/aaaa">
                        </app-masked-input>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form"
                            [readOnly]="isIndefinite"
                            controlName="max_term_validity" mask="00/00/0000"
                            label="Validade do mandato"
                            placeholder="dd/mm/aaaa">
                        </app-masked-input>
                    </div>
                </div>

                <div class="row"
                    *ngIf="companyLookupName && !loadingCompanyRepresentatives && (companyLookupStatus === 'homologado' || selectedRepresentative !== null)">
                    <div class="col-12 col-lg-6">
                        <app-radio [multiple]="true"
                            formControlName="indefinite_term">
                            Validade indeterminada
                        </app-radio>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>
            </ng-container>

            <div class="row"
                *ngIf="form.controls.representative_type.value === 'person'">
                <div class="col-12 col-lg-6 cep-container">
                    <app-masked-input [group]="form" controlName="document"
                        label="CPF" placeholder="000.000.000-00"
                        mask="000.000.000-00"
                        (onChange)="searchRepresentative($event)">
                    </app-masked-input>
                    <svg-icon src="assets/images/icon-loading.svg"
                        *ngIf="loadingRepresentative"
                        class="app-button-icon"></svg-icon>
                </div>
            </div>

            <app-spacer [bottom]="24"></app-spacer>

            <ng-container *ngIf="representativeFetched && isCpfValid()">
                <div class="row" *ngIf="isAssignor">
                    <div class="col-12">
                        <div class="d-flex align-items-center mb-2"
                            style="position: relative;">
                            <label class="pep-title mr-1" style="margin: 0;">
                                <span *ngIf="!isTypeSelected()"
                                    class="required-field"
                                    [class.error]="!isTypeSelected()">*</span>
                                Tipo de representante
                            </label>
                        </div>
                        <div class="d-flex">
                            <app-radio [multiple]="false"
                                formControlName="is_representative">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">Representante</span>
                                </div>
                            </app-radio>
                            <app-spacer [right]="24"></app-spacer>

                            <app-radio [multiple]="false"
                                formControlName="guarantor">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">Avalista</span>
                                </div>
                            </app-radio>
                            <app-spacer [right]="24"></app-spacer>

                            <app-radio [multiple]="false"
                                formControlName="solidarity_debtor">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">Devedor
                                        solidário</span>
                                </div>
                            </app-radio>
                        </div>
                        <div class="info-message" *ngIf="!isTypeSelected()"
                            style="margin-top: 8px;">
                            <svg-icon
                                src="assets/images/icon-info.svg"></svg-icon>
                            <span>
                                É obrigatório marcar um representante, avalista
                                ou devedor solidário
                            </span>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <app-input [group]="form" controlName="full_name"
                            label="Nome Completo" [maxLength]="60">
                        </app-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form"
                            controlName="birth_date" mask="00/00/0000"
                            label="Data de nascimento" placeholder="dd/mm/aaaa">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-select
                            [items]="signupService.choices().marital_choices"
                            [group]="form" controlName="marital_status"
                            [readOnly]="addingPartner" label="Estado civil"
                            placeholder="Selecione">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <ng-container
                    *ngIf="form.controls.marital_status.value === '2' || this.form.controls['marital_status'].value === '3'">
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                controlName="spouse_document"
                                label="CPF do cônjuge"
                                placeholder="000.000.000-00"
                                mask="000.000.000-00">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-8">
                            <app-masked-input [group]="form"
                                controlName="spouse_name"
                                label="Nome do cônjuge"
                                placeholder="Kátia Inácio da Silva" mask="W*"
                                [usePatterns]="true">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-12">
                            <app-select
                                [items]="signupService.choices().marital_statutes"
                                [group]="form" controlName="spouse_statute"
                                [readOnly]="addingPartner"
                                label="Regime de casamento">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12" *ngIf="showUxoria">
                            <div class="col-12" *ngIf="showUxoria">
                                <app-spacer [top]="4"></app-spacer>
                                Possui outorga uxória?
                                <app-tooltip
                                    text="É o consentimento que o cônjuge precisa dar ao outro para realizar determinados negócios jurídicos"
                                    position="top">
                                    <svg-icon src="assets/images/icon-info.svg"
                                        fill="var(--alternative-gray)"
                                        style="margin-left: 8px; cursor: pointer; font-size: 14px;"></svg-icon>
                                </app-tooltip>
                                <app-spacer [bottom]="16"></app-spacer>

                                <div class="d-flex">
                                    <app-radio
                                        [isChecked]="form.controls.spousal_consent.value === 1"
                                        (onCheckChanged)="handleSpousalConsentClick($event, 1)"
                                        [value]="1">
                                        Sim
                                    </app-radio>
                                    <app-spacer [right]="32"></app-spacer>
                                    <app-radio
                                        [isChecked]="form.controls.spousal_consent.value === 2"
                                        (onCheckChanged)="handleSpousalConsentClick($event, 2)"
                                        [value]="2">
                                        Não
                                    </app-radio>
                                </div>
                            </div>
                            <app-spacer [bottom]="48"></app-spacer>
                        </div>
                    </div>
                </ng-container>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-input [group]="form" controlName="occupation"
                            [maxLength]="30" label="Ocupação Profissional">
                        </app-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-select [items]="signupService.nationalityChocies"
                            [group]="form" controlName="nationality"
                            label="País de origem">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-select [items]="signupService.ufs_ids"
                            [group]="form" controlName="naturalness"
                            [readOnly]="isForeign" label="Naturalidade">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">

                        <app-select [items]="cities_options" [group]="form"
                            controlName="naturalness_city"
                            [readOnly]="!form.controls.naturalness.value"
                            label="Cidade"
                            [placeholder]="form.controls.naturalness.value ? 'Selecione a cidade' : 'Selecione um Estado primeiro'">
                        </app-select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-select
                            [items]="signupService.choices().document_types"
                            [group]="form" controlName="document_type"
                            label="Tipo de documento">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-input [group]="form" controlName="rg"
                            [maxLength]="20" label="Número do Documento"
                            placeholder="00000000">
                        </app-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-4">
                        <app-select [items]="signupService.issuingAgencies"
                            [group]="form" controlName="issuing_agency"
                            label="Órgão expedidor">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-3">
                        <app-select [items]="signupService.ufs" [group]="form"
                            controlName="issuing_uf" label="UF">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-5">
                        <app-masked-input [group]="form"
                            controlName="shipping_date" mask="00/00/0000"
                            label="Data expedição" placeholder="dd/mm/aaaa">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-4">
                        <app-select [group]="form" controlName="celphone_ddi"
                            [items]="DDIOptions" label="DDI">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-8">
                        <app-masked-input [group]="form"
                            controlName="celphone_number" label="Celular"
                            mask="(00) 00000-0000"
                            placeholder="(00) 00000-0000">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <app-input [group]="form" controlName="email"
                            label="E-mail">
                        </app-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>


                <div class="row" *ngIf="showTermValidity">
                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form"
                            controlName="term_validity" mask="00/00/0000"
                            label="Início do mandato" placeholder="dd/mm/aaaa">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form"
                            [readOnly]="isIndefinite"
                            controlName="max_term_validity" mask="00/00/0000"
                            label="Validade do mandato"
                            placeholder="dd/mm/aaaa">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-radio [multiple]="true"
                            formControlName="indefinite_term">
                            Validade indeterminada
                        </app-radio>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <app-radio [multiple]="true" formControlName="pep">
                            <div class="flex-1 d-flex flex-column">
                                <span class="pep-title">Considera-se
                                    PEP</span>
                                <app-spacer [bottom]="8"></app-spacer>
                                <span class="pep-description">Considera-se
                                    Pessoa Exposta Politicamente (PEP), nos
                                    termos da
                                    legislação em
                                    vigor, (i) agente público que desempenha
                                    ou
                                    tenha desempenhado, nos últimos cinco
                                    anos,
                                    no
                                    Brasil ou em
                                    países, territórios e dependências
                                    estrangeiras, cargos, empregos ou
                                    funções
                                    públicas
                                    relevantes; ou
                                    (ii) representante, familiar (parente na
                                    linha reta até primeiro grau, cônjuge,
                                    companheiro(a) ou
                                    enteado(a)).</span>
                            </div>
                        </app-radio>
                        <app-spacer [bottom]="48"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-4 cep-container">
                        <app-masked-input [group]="form" controlName="zipcode"
                            label="CEP" mask="00000-000" placeholder="00000-000"
                            (input)="handleSearchZipcode($event)">
                        </app-masked-input>
                        <svg-icon src="assets/images/icon-loading.svg"
                            *ngIf="searchingZipcode"
                            class="app-button-icon"></svg-icon>
                    </div>
                </div>
                <app-spacer [bottom]="24"></app-spacer>

                <ng-container *ngIf="zipcodeFetched">
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-input [group]="form" controlName="public_place"
                                [maxLength]="30" label="Logradouro">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-2">
                            <app-input [group]="form" controlName="number"
                                label="Número">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-input [group]="form" controlName="complement"
                                [maxLength]="20" label="Complemento">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-input [group]="form" controlName="district"
                                [maxLength]="30" label="Bairro">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-input [group]="form" controlName="city"
                                [maxLength]="30" label="Cidade">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-2">
                            <app-select [items]="signupService.ufs"
                                [group]="form" controlName="uf" label="UF">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-select
                                [items]="signupService.nationalityChocies"
                                [group]="form" controlName="country"
                                label="País">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <div class="row button-sticky">
                <div class="col-12 col-lg-6">
                    <app-button (onClick)="handleCloseModal()"
                        class="add-button" [outline]="true">
                        Cancelar
                    </app-button>
                </div>

                <ng-container
                    *ngIf="(representativeFetched && isCpfValid()) || (form.controls.representative_type.value === 'company' && companyLookupName && !loadingCompanyRepresentatives && (companyLookupStatus === 'homologado' || selectedRepresentative !== null))">
                    <div class="col-12 col-lg-6">
                        <div class="text-right">
                            <app-button (onClick)="triggerForm()"
                                [loading]="sending" [disabled]="getDisabled()"
                                type="submit" class="add-button">
                                {{ selectedRepresentative !== null ? 'Salvar
                                representante' : 'Adicionar representante' }}
                            </app-button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>


    </app-side-modal>


    <div *ngIf="showPartnerHelpText" class="mt-3 text-danger">
        <p>
            Alguns representantes necessitam do cadastro do cônjuge.<br>
            Clique no icone "<svg-icon
                src="assets/images/icon-rings-wedding.svg"></svg-icon>" para
            concluir o cadastro do representante.
        </p>
    </div>

    <app-warning-modal [active]="removeModal" (onClose)="handleRemoveCancel()">
        <h3>Você tem certeza?</h3>
        <app-spacer [bottom]="24"></app-spacer>
        <p>Você não poderá reverter essa ação!</p>
        <app-spacer [bottom]="56"></app-spacer>

        <app-button (onClick)="handleRemoveCancel()" [center]="true"
            class="add-button">
            Cancelar
        </app-button>

        <app-spacer [bottom]="8"></app-spacer>

        <app-button (onClick)="removeData(selectedIndex)" class="add-button"
            [center]="true" [outline]="true" [loading]="deletingRepresentative"
            [disabled]="deletingRepresentative">
            Sim, apague!
        </app-button>
    </app-warning-modal>

    <app-warning-modal [active]="warningRemoveModal"
        (onClose)="warningRemoveModal = false">
        <h3>Atenção</h3>
        <app-spacer [bottom]="24"></app-spacer>
        <p>
            Você não pode remover um representante que pertence a um grupo de
            poder de assinatura.
        </p>

        <p>
            Para remover esse representante, remova o grupo de poder de
            assinatura.
        </p>
        <app-spacer [bottom]="56"></app-spacer>

        <app-button (onClick)="warningRemoveModal = false" [center]="true"
            class="add-button">
            Ok
        </app-button>
    </app-warning-modal>

    <app-warning-modal [active]="showPendingPartnerMessage"
        (onClose)="showPendingPartnerMessage = false"
        *ngIf="alreadyShowPendingPartnerMessage">
        <h3>Atenção</h3>
        <app-spacer [bottom]="24"></app-spacer>
        <p>
            Os usuários não possuem outorga uxória. É necessário cadastrar o
            cônjuge para continuar.
        </p>
        <app-spacer [bottom]="56"></app-spacer>

        <app-button (onClick)="showPendingPartnerMessage = false"
            [center]="true" class="add-button">
            Ok
        </app-button>
    </app-warning-modal>
</form>